export function toFixedWithoutRounding(number, decimalPlaces = 0) {
  if (typeof number !== 'number') return number

  const multiplier = Math.pow(10, decimalPlaces)
  const truncated = Math.trunc(number * multiplier) / multiplier
  return truncated.toFixed(decimalPlaces)
}
